import { Link } from "react-router-dom";
import { genres } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-open-line text-xl" />
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-950">
                JM<span className="text-primary-500">comic2</span>
              </span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed max-w-md">
              JMcomic2 专注于正版高清漫画在线阅读，涵盖少年、少女、青年、同人、奇幻、科幻、恋爱、动作等多种题材，为每一位漫迷提供流畅的阅读体验与及时的更新提示。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-weibo-line", "ri-wechat-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-full bg-background-100 border border-background-200 flex items-center justify-center text-foreground-700 hover:text-primary-500 hover:border-primary-400 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              <Link to="/category" className="hover:text-primary-500 transition-colors">
                题材分类
              </Link>
            </h4>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-4">
              {genres.map((genre) => (
                <li key={genre}>
                  <Link
                    to={`/category?genre=${encodeURIComponent(genre)}`}
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors"
                  >
                    {genre}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              <Link to="/about" className="hover:text-primary-500 transition-colors">
                关于我们
              </Link>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors">
                  平台介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors">
                  合作与版权
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors">
                  意见反馈
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors">
                  全部漫画
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 JMcomic2 高清漫画在线阅读平台 · 本站内容均为演示示例，版权归原作者所有
          </p>
          <p className="text-xs text-foreground-500">
            仅供学习交流使用 · 请支持正版漫画
          </p>
        </div>
      </div>
    </footer>
  );
}